<div class="inyova-grow-doc" (click)="openDocPDF(doc, title)" *ngIf="doc">
  <app-ds-icon name="file-text"></app-ds-icon>
  <span class="ds-ui-2">{{ title }}</span>
</div>
